import { useState } from "react";
import type { ChatPerson } from "../../api/chat";
import { initials, toneOf } from "./chatFormat";

/**
 * A colleague's picture, or their initials on a colour that is theirs on every screen. A green dot says they have
 * the chat open right now.
 */
export function ChatAvatar({
  person,
  id,
  size = "md",
  online = false,
}: {
  person: ChatPerson | undefined;
  id: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  online?: boolean;
}) {
  const [broken, setBroken] = useState(false);
  const name = person?.name ?? "?";
  return (
    <span className={`chat-av ${size} t${toneOf(id)}`} aria-hidden="true">
      {person?.avatarUrl && !broken ? (
        // A picture that does not load (its link expired) gives way to the initials; nothing here is clicked.
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <img src={person.avatarUrl} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : (
        initials(name)
      )}
      {online && <span className="chat-av-dot" />}
    </span>
  );
}
